import { useEffect } from 'react'

/**
 * Wrapper that forces light theme while mounted — used for client-facing
 * public pages (questionnaires, contract accept, offer accept, galleries)
 * that should always render in light mode regardless of user preference.
 */
export function ForceLightTheme({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const root = document.documentElement
    const wasDark = root.classList.contains('dark')
    const prevColorScheme = root.style.colorScheme

    // Force light
    root.classList.remove('dark')
    root.style.colorScheme = 'light'

    return () => {
      // Restore previous state
      if (wasDark) {
        root.classList.add('dark')
        root.style.colorScheme = 'dark'
      } else {
        root.style.colorScheme = prevColorScheme
      }
    }
  }, [])

  return <>{children}</>
}

